import { GameConstants } from "../../GameConstants";
import { StageContainer } from "./StageContainer";
import { ChickenManager } from "./chickens/ChickenManager";
import { ConnectionManager } from "../../ConnectionManager";
import { GameManager } from "../../GameManager";
import { GameVars } from "../../GameVars";
import { RoadState } from "./RoadState";

export class RoadManager {

    private static game: Phaser.Game;
    private static f: number;

    public static init(game: Phaser.Game): void {

        RoadManager.game = game;
        RoadManager.f = 0;

        GameVars.freezeAction = false;
        GameVars.featherSpeed = false;
        GameVars.paused = false;
        GameVars.savedChicken = 0;
        GameVars.score = 0;
        GameVars.crosses = 0;
        GameVars.streak = 0;
        GameVars.time = this.game.time.now;
        GameVars.gameOver = false;
        GameVars.riverSide = GameConstants.RIVER_LEFT;

        GameVars.deaths = 0;
        GameVars.drowned = 0;
        GameVars.feathers = 0;
    }

    public static removeInstructionsLayer(): void {

        RoadState.currentInstance.removeInstructionsLayer();

        GameManager.onDesktopTutorialSeen();
    }

    public static newTime(): void {

        GameVars.chickenTime = this.game.time.now;
    }

    public static freezeAction(freeze: boolean): void {

        GameVars.freezeAction = freeze;

        if (StageContainer.currentInstance.chicken) {
            StageContainer.currentInstance.chicken.changeFrameRate();
        }

        ChickenManager.changeFrameRate();
    }

    public static moveChicken(x: number, y: number): void {
        
        RoadState.currentInstance.moveChicken(x, y);
    }

    public static onChickenSaved(x: number, y: number): void {

        GameVars.savedChicken ++;
        GameVars.streak ++;
        GameVars.crosses++;
         
        let time = (this.game.time.now - GameVars.chickenTime) / 1000;

        let points = 1000;

        if (time > 15) {
            points = 500;
        } else if (time >= 5) {
            let timeAux = Math.abs((time - 5) - 10);
            points = 500 + (timeAux * 500) / 10;
        }

        points = Math.ceil(points / 5) * 5;

        GameVars.score += points;

        RoadState.currentInstance.onChickenSaved(x, y, points);
    }

    public static onChickenHit(): void {

        GameVars.deaths ++;
        
        if (GameVars.streak > GameVars.gameData.stats.streak) {
            GameVars.gameData.stats.streak = GameVars.streak;
        }
        
        GameVars.streak = 0;
    }

    public static onChickenDrowned(): void {

        GameVars.deaths ++;
        GameVars.drowned ++;

        if (GameVars.streak > GameVars.gameData.stats.streak) {
            GameVars.gameData.stats.streak = GameVars.streak;
        }
        
        GameVars.streak = 0;
        RoadState.currentInstance.onChickenDrowned();
    }

    public static onRagdollCollision(x: number, y: number): void {

        if (GameVars.gameOver) {
            return;
        }

        if (y < 0 || y > 450) {
            return;
        }

        GameVars.score += 5;
        RoadState.currentInstance.onChickenHit(x, y);
    }

    public static onCloseCall(x: number, y: number): void {

        GameVars.gameData.stats.closeCalls++;
        GameVars.score += 200;

        RoadState.currentInstance.onCloseCall(x, y);
    }

    public static gameOver(): void {

        GameVars.gameOver = true;

        GameVars.gameData.stats.deaths += GameVars.deaths;
        GameVars.gameData.stats.feathers += GameVars.feathers;
        GameVars.gameData.stats.drowned += GameVars.drowned;

        RoadManager.freezeAction(false);
       
        if (GameConstants.SPONSOR === GameConstants.SPONSOR_GAMEPIND) {
            ConnectionManager.sendHighscore();
        }

        if (GameVars.crosses > GameVars.gameData.stats.crosses) {
            GameVars.gameData.stats.crosses = GameVars.crosses;
        }

        if (GameVars.score > GameVars.gameData.stats.highscore) {

            GameVars.gameData.stats.highscore = GameVars.score;

            if (GameConstants.SPONSOR === GameConstants.SPONSOR_LAGGED) {

                const boardinfo: any = {};
                boardinfo.score = GameVars.score;
                boardinfo.board = "gochick_ensgoo_hbbrdsg";
                LaggedAPI.Scores.save(boardinfo, function(response: any) {
                    if (response.success) {
                        console.log("high score saved");
                    } else {
                        console.log(response.errormsg);
                    }
                });
            }
        }

        if (GameConstants.SPONSOR === GameConstants.SPONSOR_GAMEPIX) {

            RoadManager.game.time.events.add(850, function(): void {
                GamePix.game.ping("level_complete", { score: GameVars.score, level: 0, achievements: {/*INSERT HERE IF AVAILABLE*/ } });
                RoadState.currentInstance.showFinalLayer();
            }, RoadManager);

        } else {

            if (GameConstants.SPONSOR === GameConstants.SPONSOR_GAME_DISTRIBUTION) {
                if (typeof gdsdk !== "undefined" && gdsdk.showAd !== "undefined") {
                    gdsdk.showAd();
                }
            }
            RoadState.currentInstance.showFinalLayer();
        }

        GameManager.writeGameData();

        GameManager.computeAchievements();
    }

    public static jump(): void {

        StageContainer.currentInstance.chicken.jump();
    }

    public static takeFeather(): void {

        GameVars.feathers ++;
        GameVars.score += 150;

        RoadState.currentInstance.featherPicked();

        GameVars.featherSpeed = true;

        this.game.time.events.add(10 * Phaser.Timer.SECOND, function(): void {
            RoadManager.endFeatherSpeed();
        }, this);
    }

    public static endFeatherSpeed(): void {
        
        GameVars.featherSpeed = false;
        StageContainer.currentInstance.feather.startDelayFeather();
    }
}
